import styled from 'styled-components';

export const Svg = styled.svg`
  // display: block;
  height: 30px;
  // fill: rgb(240, 235, 235);
  // fill : #333;
  fill: #337ab7;
  &:hover {
    cursor: pointer;
  }
`;
